<template>
  <div id="presentbox">
    <img :src="'static/image/presentbox/'+box.image" class="immagine">
    <div class="row">
      <div class="col-lg-12 nomeVino">{{box.nome}}</div>
      <div class="col-lg-12 desc" v-html="box.descr"></div>
      <div class="col-lg-6 col-sm-6 col-md-6 col-6 price" v-price>{{box.price}}</div>
      <div class="col-lg-6 col-sm-6 col-md-6 col-6 quantity">Qtà:&nbsp;<input type="number" name="quantity"
                                                                              min="1" class="quantità"
                                                                              id="qua"
                                                                              oninput="validity.valid||(value=1)"
                                                                              v-model="qntyOrd"
                                                                              v-validate="'required'">
      </div>
      <div class="col-lg-12 scheda">
        <!--<router-link :to="{name: 'schedavini', params: {id: box.id}}">Scheda</router-link>-->
      </div>
      <b-btn class="bottone" @click="addToCart">Aggiungi al carrello</b-btn>
    </div>
  </div>
</template>

<script>
import Bus from './Bus'
export default {
  name: "PresentBox",
  data () {
    return {
      qntyOrd: 1
    }
  },
  computed: {
    subTot: function () {
      return this.box.qntyOrd * this.box.price
    }
  },
  props: {
    box: {type: Object}
  },
  methods: {
    totale: function () {
      this.$emit('totCart')
    },
    checkAvailability: function (available, qntyProd) {
      let d = new Date();
      if (moment(d).isAfter(available) & qntyProd > 0) {
        return true
      } else return false
    },
    addToCart: function () {
      let idCarrello = localStorage.getItem('idCarrello') === null || localStorage.getItem('idCarrello') === undefined ? '0' : localStorage.getItem('idCarrello')
      let data = {
        idCartEncrypted: idCarrello,
        idProduct: this.box.idProduct,
        qntyOrd: this.qntyOrd
      }
      this.$http.post('/ws-shop/cart/add', data).then(response => {
        if (response.body.idCart) {
          localStorage.setItem('idCarrello', response.body.idCart)
        }
        if (response.body.rc === 0) {
          this.$toasted.show(this.$t('prod_add'), {
            theme: 'primary',
            position: 'bottom-right',
            type: 'success',
            duration: 4000
          })
          Bus.$emit('totCart')
        } else {
          this.$toasted.show(this.$t('prb_prod_add'), {
            theme: 'primary',
            position: 'bottom-right',
            type: 'error',
            duration: 4000
          })
        }
      })
    }
  },
  i18n: {
    fallbackLocale: 'it', // default lang,
    messages: {
      it: {
        prod_add: 'Prodotto aggiunto al carrello',
        prb_prod_add: 'Errore, inserire quantità'
      },
      en: {
        prod_add: 'Prodotto aggiunto al carrello',
        prb_prod_add: 'Errore, inserire quantità'
      }
    }
  }
}
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  #presentbox {

    .row {
      margin-left: 0px;
      margin-right: 0px;
      input[type=number] {
        text-align: center;
        font-weight: 700;
        outline: none;
      }
      /*input[type=number]::-webkit-inner-spin-button,*/
      /*input[type=number]::-webkit-outer-spin-button {*/
      /*-webkit-appearance: initial;*/
      /*margin: 0;*/
      /*}*/
    }

    border: .5px;
    border-style: solid;
    border-color: white;
    text-align: center;
    width: 65%;
    margin: auto;
    background-color: @lightBlack;
    padding: 20px;
    letter-spacing: 1px;
    .set-font-title(@size: 25px);
    .nomeVino {
      .set-font-latoLight(@size: 30px);
    }
    .quantity {
      .set-font-latoRegular();
      .quantità {
        width: 40%;
        height: 90%;
        background-color: #585353;
        color: white;
        border-color: @darkGray;
      }
    }
    .immagine {
      width: 50% !important;
      min-height: 250px;
    }
    .desc {
      text-align: left;
      min-height: 63px;
      .set-font-latoLight(@size: 16px);
    }
    .price {
      text-align: left;
      color: @lightGold;
      .set-font-latoRegular(@color: light-green);
    }
    .scheda {
      text-align: left;
      margin-bottom: 15px;
      .set-font-latoBold();
    }
    .info {
      border: 1px solid white;
      padding: 9px;
      width: 50% !important;
      margin: 40px auto;
      .set-font-latoLight();
    }
    .bottone {
      width: 200px;
      background-color: @myOrange;
      border-color: @borderOrange;
      margin: auto;
      text-align: center;
      display: inherit;
      letter-spacing: 1px;
      margin-bottom: 15px;
      .set-font()
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/PresentBox.vue